import iconUrl from '../assets/markroom-icon.svg';

/**
 * The MarkRoom logomark — the blue archway with the navy "M" — on a transparent
 * background (no chip). The colored arch keeps it legible on light and dark.
 */
export function Logo({ size = 24 }: { size?: number }) {
  return (
    <span className="mr-logo" style={{ width: size, height: size }} aria-hidden="true">
      <img src={iconUrl} alt="" draggable={false} />
    </span>
  );
}
